export default __webpack_public_path__ + "static/media/meal-1.3e89775c.svg";